import theme from "../../styles/__theme";
import { keyframes } from "../../utils/barrels/emotion-react";
import { styled } from "../../utils/barrels/emotion-styled";

const { colors, spacing, fontSize, fontWeight, borderRadius } = theme;

const progressAnimation = keyframes`
  0% {
    width: 0%;
    transform: translateX(0);
  }
  20% {
    width: 20%;
    transform: translateX(0);
  }
  50% {
    width: 60%;
    transform: translateX(0);
  }
  80% {
    width: 20%;
    transform: translateX(80%);
  }
  100% {
    width: 0%;
    transform: translateX(100%);
  }
`;

export const LoaderContainer = styled.div`
	width: 100vw;
	height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	position: fixed;
	top: 0;
	left: 0;
	background: linear-gradient(180deg, #f4f5f6 0%, #ffffff 100%);
	z-index: 999;
	padding: ${spacing.massive} ${spacing.large};
	box-sizing: border-box;
	overflow-y: auto;
`;

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	max-width: 500px;
`;

export const LogoContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-bottom: ${spacing.xxLarge};
`;

export const LogoWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: ${spacing.large};
`;

export const Heading = styled.h1`
	font-size: 2rem;
	font-weight: ${fontWeight.bold};
	color: ${colors.black};
	margin: 0;
	margin-bottom: ${spacing.moderate};
	text-align: center;
	font-family: "Inter", "Helvetica", "Arial", sans-serif;
	line-height: 1.3;

	@media (max-width: 768px) {
		font-size: 1.25rem;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;

export const SubHeading = styled.p`
	font-size: ${fontSize.large};
	font-weight: ${fontWeight.normal};
	color: ${colors.silverGrey};
	margin: 0;
	margin-bottom: 48px;
	text-align: center;
	font-family: "Inter", "Helvetica", "Arial", sans-serif;

	@media (max-width: 768px) {
		font-size: ${fontSize.moderate};
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;

export const CarouselContainer = styled.div`
	width: 100%;
	max-width: 500px;
	margin-bottom: ${spacing.large};
	position: relative;

	@media (max-width: 768px) {
		max-width: 90%;
	}
`;

export const FeatureCard = styled.div`
	background: ${colors.white};
	border-radius: 16px;
	padding: ${spacing.xLarge};
	display: flex;
	align-items: center;
	gap: ${spacing.large};
	width: 100%;
	box-shadow:
		0 4px 20px rgba(0, 0, 0, 0.08),
		0 2px 8px rgba(0, 0, 0, 0.06);
	transition: all 0.3s ease;
	opacity: ${(props) => (props.isAnimating ? 0 : 1)};
	transform: ${(props) => (props.isAnimating ? "scale(0.95)" : "scale(1)")};

	@media (max-width: 768px) {
		padding: ${spacing.moderate};
		gap: ${spacing.moderate};
		border-radius: 12px;
		max-width: 280px;
		margin: 0 auto;
	}
`;

export const IconBox = styled.div`
	width: 64px;
	height: 64px;
	background: ${colors.lightPurple};
	border-radius: ${borderRadius.comfortable};
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	box-shadow: 0 2px 8px rgba(111, 87, 232, 0.2);

	@media (max-width: 768px) {
		width: 48px;
		height: 48px;
		border-radius: ${borderRadius.regular};
	}
`;

export const FeatureText = styled.p`
	font-size: ${fontSize.large};
	font-weight: ${fontWeight.normal};
	color: ${colors.black};
	margin: 0;
	font-family: "Inter", "Helvetica", "Arial", sans-serif;

	@media (max-width: 768px) {
		font-size: ${fontSize.moderate};
		line-height: 1.4;
	}
`;

export const ProgressBarContainer = styled.div`
	width: 100%;
	max-width: 500px;
	height: 4px;
	background: ${colors.lightGrey};
	border-radius: ${borderRadius.tiny};
	overflow: hidden;
	margin-bottom: ${spacing.xxLarge};
`;

export const ProgressBar = styled.div`
	height: 100%;
	background: linear-gradient(
		90deg,
		${colors.purple} 0%,
		${colors.darkPurple} 50%,
		${colors.purple} 100%
	);
	background-size: 200% 100%;
	border-radius: ${borderRadius.tiny};
	animation: ${progressAnimation} 2.5s cubic-bezier(0.4, 0, 0.2, 1) infinite;
	position: relative;
	will-change: transform, width;
	backface-visibility: hidden;
	-webkit-backface-visibility: hidden;
`;

export const InstructionText = styled.p`
	font-size: ${fontSize.moderate};
	font-weight: ${fontWeight.normal};
	color: ${colors.silverGrey};
	margin: 0;
	margin-top: ${spacing.xxLarge};
	text-align: center;
	font-family: "Inter", "Helvetica", "Arial", sans-serif;
	width: 100%;
`;
